// features/userSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getUserDetail } from "../../utilities/services/user";

// Async thunk to fetch user details
export const fetchUserDetail = createAsyncThunk(
  "user/fetchUserDetail",
  async (id) => {
    const response = await getUserDetail(id);
    return response.data;
  }
);

const userSlice = createSlice({
  name: "user",
  initialState: {
    user: [],
    loading2: false,
    error: null,
  },
  reducers: {
    clearUser: (state) => {
      state.user = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserDetail.pending, (state) => {
        state.loading2 = true;
        state.error = null;
      })
      .addCase(fetchUserDetail.fulfilled, (state, action) => {
        state.loading2 = false;
        state.user = action.payload;
      })
      .addCase(fetchUserDetail.rejected, (state, action) => {
        state.loading2 = false;
        state.error = action.payload;
      });
  },
});

export const { clearUser } = userSlice.actions;

export default userSlice.reducer;
